<!-- 运营详情 -->

<template>
  <div class="operation-detail-dialog">
    <w-dialog ref="dialogRef" title="详情" width="60%" top="15vh" :hideFooter="true">
      <el-row :gutter="20">
        <el-col :span="9">
          <div class="flex-btw align-center">
            <w-title :title_name="'出车详情'"></w-title>
            <div>{{ infoData.car_records.time }}</div>
          </div>

          <div class="outward-run">
            <div class="flex align-center remain-seats">
              <img src="@/assets/img/seat.png" class="outward-img" />
              <div>剩余座位：{{ infoData.car_records.available_count }}</div>
            </div>

            <div class="m-m-t">
              <div class="flex align-center">
                <div class="left-title">车牌：</div>
                <div class="left-content">{{ infoData.car_records.car_plate }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">路线：</div>
                <div class="left-content">{{ infoData.car_records.departure_place }} - {{
                  infoData.car_records.arrival_place }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">发车时间：</div>
                <div class="left-content">{{ infoData.car_records.departure_time }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">预计抵达：</div>
                <div class="left-content">{{ infoData.car_records.arrival_time }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">途经点：</div>
                <div class="left-content">{{ infoData.car_records.stopover_place ? infoData.car_records.stopover_place : '-' }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">乘车人数：</div>
                <div class="left-content">{{ infoData.car_records.count }}</div>
              </div>
              <div class="flex align-center s-m-t">
                <div class="left-title">司机：</div>
                <div class="left-content">{{ infoData.car_records.driver_name }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="flex align-center">
            <w-title :title_name="'乘车记录'"></w-title>
            <div>（共计{{ infoData.car_records_list.length }}条）</div>
          </div>

          <common-table ref="tableRef" tableHeight="500" :columns="tableColumns" :ispaging="false"
            :tableData="infoData.car_records_list">
          </common-table>
        </el-col>
      </el-row>
    </w-dialog>
  </div>
</template>

<script>
import { ref, nextTick, } from "vue";
import { VipApi, } from "@/plugins/api.js";

export default {
  emits: ["submit"],
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const infoData = ref({});  // 详情数据
    const tableRef = ref(null);  // 表格对象
    /** 表格配置数据 */
    const tableColumns = ref([
      {
        prop: "contact_name",
        label: "约车人",
      },
      {
        prop: "contact_mobile",
        label: "联系电话",
      },
      {
        prop: "count",
        label: "乘车人数",
      },
      {
        prop: "source_text",
        label: "数据来源",
      },
      {
        prop: "departure_place",
        label: "上车点",
      },
      {
        prop: "arrival_place",
        label: "下车点",
      },
    ]);

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      getDetailsData();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }

    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getDetailsData = () => {
      VipApi.getCarRecordsDetail({ id: currentRow.value.id, }).then((res) => {
        if (res.Code == 200) {
          dialogRef.value.show();
          res.Data.car_records.time = res.Data.car_records.departure_time.split(' ')[0];
          infoData.value = res.Data;
          nextTick(() => {
            tableRef.value.tableLoad();
          })
        }
      });
    }
    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      getDetailsData,
      infoData,
      tableRef,
      tableColumns,
    };
  },
};
</script>

<style lang="scss">
.operation-detail-dialog {
  .outward-run {
    .outward-img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    .remain-seats {
      height: 60px;
      background-color: var(--search-bg-color);
      border-radius: 4px;
      padding: 0 15px;
    }

    .left-title {
      color: #92979E;
      width: 70px;
    }

    .left-content {
      color: #262C30;
    }
  }
}
</style>